import { z } from 'zod';
export const ModelType = z.enum([
    'agriculture-thresher',
    'agriculture-tools',
    'agriculture-tractor',
    'atv',
    'boat-dock',
    'boat-motor',
    'boat-new-sale',
    'boat-rent',
    'boat-sale',
    'boat-wanted',
    'bus',
    'car-leasing',
    'car-leasing-business',
    'car-new',
    'car-used',
    'car-used-business',
    'caravan',
    'construction',
    'mobile-home',
    'moped',
    'motorcycle',
    'snowmobile',
    'truck',
    'a-tractor',
]);
